import { render, staticRenderFns } from "./BsoAndEbsoSection.vue?vue&type=template&id=61408d19&scoped=true"
import script from "./BsoAndEbsoSection.vue?vue&type=script&lang=js"
export * from "./BsoAndEbsoSection.vue?vue&type=script&lang=js"
import style0 from "./BsoAndEbsoSection.vue?vue&type=style&index=0&id=61408d19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61408d19",
  null
  
)

export default component.exports